import { FacebookOutlined, HomeOutlined, InfoCircleOutlined, InstagramOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import { FloatButton } from 'antd';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <>
      <DefaultFooter
        style={{
          background: 'none',
        }}
        links={[
          {
            key: 'home-icon',
            title: <HomeOutlined />,
            href: 'https://dhhp.edu.vn',
            blankTarget: true,
          },
          {
            key: 'instagram-icon',
            title: <InstagramOutlined />,
            href: 'https://www.instagram.com/hpu.off/',
            blankTarget: true,
          },
          {
            key: 'fb-icon',
            title: <FacebookOutlined />,
            href: 'https://www.facebook.com/HaiPhongUniversity',
            blankTarget: true,
          }
        ]}
        copyright="2024 Trường Đại học Hải Phòng"
        className='quicksand'
      />
      <FloatButton icon={<InfoCircleOutlined />} tooltip="Hỗ trợ kỹ thuật: 0762559696" />
    </>
  );
};

export default Footer;
